var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79011 0.99036C15.1601 0.52036 19.8601 7.17036 17.0401 12.9804C16.7401 13.6004 16.3001 14.1304 15.9401 14.7004L20.8601 19.6404C21.3801 20.4304 20.3601 21.4604 19.6001 20.8504L14.6301 15.9004L14.5201 15.9204C13.4001 16.8104 12.0001 17.4704 10.5801 17.7004C8.56011 18.0304 6.41011 17.5404 4.71011 16.4204C4.37011 16.2004 3.57011 15.6004 3.38011 15.2704C2.90011 14.4304 3.86011 13.6204 4.65011 14.2004C5.71011 14.9804 6.14011 15.5404 7.53011 15.9304C13.7201 17.6404 18.6001 10.7604 14.8101 5.51036C11.4701 0.880361 4.05011 2.24036 2.81011 7.85036C2.68011 8.45036 2.72011 8.99036 2.63011 9.54036C2.50011 10.4004 1.16011 10.5404 1.02011 9.54036C0.960109 9.13036 1.06011 8.41036 1.13011 7.99036C1.74011 4.22036 4.97011 1.27036 8.79011 0.99036Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01017 8.62988H12.5602C13.5302 8.65988 13.7902 10.0499 12.7702 10.2399H5.89017C4.95017 9.98988 4.98017 8.70988 6.00017 8.62988H6.01017Z",
    fill: "#223D51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.12 6.11051V12.6605C10.09 13.6305 8.70001 13.8905 8.51001 12.8705V5.99051C8.76001 5.05051 10.04 5.08051 10.12 6.10051V6.11051Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/zoomInIcon.8f39c278cf9bc3523b4cc11ac41e3d54.svg";
export { ForwardRef as ReactComponent };